export default {
      id: "remove_circle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#remove_circle",
      toString: function () {
        return this.url;
      }
    }